import { Resource } from "./Resource";
export class AtlasResource extends Resource {
    constructor(dir, textures, frames) {
        super();
        this.dir = dir;
        this.textures = textures;
        this.frames = frames;
        for (let tex of frames) {
            tex._addReference();
            tex._atlas = this;
        }
        for (let tex of textures) {
            tex._addReference();
            tex._atlas = this;
        }
    }
    update(textures, frames) {
        this._disposeResource();
        this.textures.push(...textures);
        this.frames.push(...frames);
        for (let tex of frames) {
            tex._addReference();
            tex._atlas = this;
        }
        for (let tex of textures) {
            tex._addReference();
            tex._atlas = this;
        }
    }
    _disposeResource() {
        for (let tex of this.textures) {
            tex._atlas = null;
            tex._removeReference();
        }
        for (let tex of this.frames) {
            tex._atlas = null;
            tex._removeReference();
        }
        this.frames.length = 0;
        this.textures.length = 0;
    }
}
